import React from 'react';

import Table from '@/components/ui/table/Table';
import ConjunctionSelect from '@/components/core/select/ConjunctionSelect';
import { useConjunctionTable } from './conjunctionTableHooks';

type ConjunctionTableProps = {
  queryKey: number;
  limit: number;
  totalPage: number;
  title: string;
  description: string;
  showPagination?: boolean;
};

export const headers = ['Primary', 'Secondary', 'TCA(UTC)', 'DCA(km)', 'PoC'];
export const columns = ['pName', 'sName', 'tcaTime', 'dca', 'poc'];

export const ConjunctionTable = ({
  queryKey,
  limit,
  totalPage,
  title,
  description,
  showPagination = true,
}: ConjunctionTableProps) => {
  const {
    selected,
    setSelected,
    page,
    setPage,
    isLoading,
    isFetching,
    tableData,
    startCollection,
    endCollection,
  } = useConjunctionTable({ limit, queryKey });
  const SELECT_TYPE = 'HOME';

  return (
    <div className='relative flex flex-col xl:w-full h-full gap-2 md:w-[668px]'>
      <header className='m-0 text-white flex items-center justify-between'>
        <h3 className='m-0 p-0 text-base font-semibold text-[#A7A7A7] '>
          {title}
          <div className='text-sm font-medium m-0 self-center text-[#6C6C6C]'>
            {description}
          </div>
          <div className='text-sm font-medium m-0 self-center text-[#6C6C6C]'>
            <p>Prediction Window : {startCollection} ~ {endCollection} (UTC)</p>
          </div>
        </h3>
        <ConjunctionSelect
          selected={selected}
          setSelected={setSelected}
          type={SELECT_TYPE}
        />
      </header>
      <Table
        headers={headers}
        columns={columns}
        data={tableData}
        isLoading={isLoading || isFetching}
        limit={limit}
        showPagination={showPagination}
        {...(showPagination && {
          page: page,
          setPage: setPage,
          totalPages: totalPage,
        })}
      />
    </div>
  );
};

export default React.memo(ConjunctionTable);
